import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import ExploreCard from "Pages/Home/ExploreCard";

const ExploreTheme = () => {
  return (
    <>
      <Header />
      <ExploreCard />
      <Latestupdate />
      <Footer />
    </>
  );
};
export default ExploreTheme;
